// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditPhoneNumber-module__EditPhoneNumberContainer___ieAGG{
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
    text-align: center;
}

.EditPhoneNumber-module__dial_code_select___bwUtF {
    color: #7D7D7D;
    background-color: #f8f9fa;
    padding: 10px;
    outline: none;
    border: none;
    border-radius: 5px 0 0 5px;
  }

  .EditPhoneNumber-module__mobile_number_input___yGIlS {
    border: none;
    font-size: 18px;
    outline: none;
  }

  .EditPhoneNumber-module__editHeader___hdgvi{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .EditPhoneNumber-module__nextButton___ONQxm{
    cursor: pointer;
    margin-top: 12px;
    height:30px;
    width: 100%;
    color: #fff;
    background-color: #263643;
    border: 1px solid #263643;
  }

  .EditPhoneNumber-module__closeBtn___hTUaj {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: #333;
  }`, "",{"version":3,"sources":["webpack://./src/modals/editphonenumber/EditPhoneNumber.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;EACb","sourcesContent":[".EditPhoneNumberContainer{\n    background: #fff;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n    position: relative;\n    text-align: center;\n}\n\n.dial_code_select {\n    color: #7D7D7D;\n    background-color: #f8f9fa;\n    padding: 10px;\n    outline: none;\n    border: none;\n    border-radius: 5px 0 0 5px;\n  }\n\n  .mobile_number_input {\n    border: none;\n    font-size: 18px;\n    outline: none;\n  }\n\n  .editHeader{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .nextButton{\n    cursor: pointer;\n    margin-top: 12px;\n    height:30px;\n    width: 100%;\n    color: #fff;\n    background-color: #263643;\n    border: 1px solid #263643;\n  }\n\n  .closeBtn {\n    background: none;\n    border: none;\n    font-size: 22px;\n    cursor: pointer;\n    color: #333;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EditPhoneNumberContainer": `EditPhoneNumber-module__EditPhoneNumberContainer___ieAGG`,
	"dial_code_select": `EditPhoneNumber-module__dial_code_select___bwUtF`,
	"mobile_number_input": `EditPhoneNumber-module__mobile_number_input___yGIlS`,
	"editHeader": `EditPhoneNumber-module__editHeader___hdgvi`,
	"nextButton": `EditPhoneNumber-module__nextButton___ONQxm`,
	"closeBtn": `EditPhoneNumber-module__closeBtn___hTUaj`
};
export default ___CSS_LOADER_EXPORT___;
